export default __webpack_public_path__ + "c4f6d5af45b016e4c7753e5600a9a85d.png";